import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface LotteryPurchaseEntry {
  id: number;
  date: string;
  invoiceNumber: string;
  bookId: string;
  totalBookAmount: number;
  ticketValue: number;
  ticketsInBook: number;
  userId: number;
  createdDate: number;
}

export interface CreateLotteryPurchaseRequest {
  date?: string;
  invoiceNumber: string;
  bookId: string;
  totalBookAmount: number;
  ticketValue?: number;
  ticketsInBook?: number;
}

export type UpdateLotteryPurchaseRequest = Partial<CreateLotteryPurchaseRequest>;

export interface PaginatedLotteryPurchaseResponse {
  data: LotteryPurchaseEntry[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const lotteryPurchaseApi = {
  getEntries: async (
    params: { page?: number; limit?: number },
    token: string
  ): Promise<PaginatedLotteryPurchaseResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.limit) searchParams.append('limit', params.limit.toString());
    const query = searchParams.toString();
    return apiRequest<PaginatedLotteryPurchaseResponse>(
      buildApiUrl(`${API_CONFIG.ENDPOINTS.LOTTERY_PURCHASE.BASE}${query ? `?${query}` : ''}`),
      {
        method: 'GET',
        headers: getAuthHeaders(token),
      }
    );
  },

  createEntry: async (data: CreateLotteryPurchaseRequest, token: string): Promise<LotteryPurchaseEntry> => {
    return apiRequest<LotteryPurchaseEntry>(
      buildApiUrl(API_CONFIG.ENDPOINTS.LOTTERY_PURCHASE.BASE),
      {
        method: 'POST',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },

  updateEntry: async (id: number, data: UpdateLotteryPurchaseRequest, token: string): Promise<LotteryPurchaseEntry> => {
    return apiRequest<LotteryPurchaseEntry>(
      buildApiUrl(API_CONFIG.ENDPOINTS.LOTTERY_PURCHASE.BY_ID(id)),
      {
        method: 'PUT',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },

  deleteEntry: async (id: number, token: string): Promise<void> => {
    return apiRequest<void>(
      buildApiUrl(API_CONFIG.ENDPOINTS.LOTTERY_PURCHASE.BY_ID(id)),
      {
        method: 'DELETE',
        headers: getAuthHeaders(token),
      }
    );
  },
};
